import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import image1 from "../../assets/promosi/1.jpg";
import image2 from "../../assets/promosi/2.png";
import image3 from "../../assets/promosi/3.png";

const images = [
  image1,
  image2,
  image3,
];

const Slideshow = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0', // Tidak ada padding di tengah
    autoplay: true, // Aktifkan autoplay
    autoplaySpeed: 4000, // Atur kecepatan autoplay dalam milidetik (misalnya, setiap 3 detik)
  };

  const imageStyle = {
    width: '600px', // Lebar gambar tetap 100%
    height: 'auto', // Tinggi disesuaikan agar gambar tidak terdistorsi
    objectFit: 'cover', // Pastikan gambar selalu terisi di dalam area yang ditentukan
  };

  const slideshowStyle = {
    width: '600px', // Mengatur lebar carousel
    margin: '20px auto', // Meletakkan carousel di tengah
  };

  return (  
    <div style={slideshowStyle}>
      <br /><br /><br /><br />
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <img src={image} alt={`slide ${index + 1}`} style={imageStyle} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Slideshow;
